import React from "react";
import { graphql, compose } from "react-apollo";
import gql from "graphql-tag";
import List from "./List";
import moment from "moment-timezone";
class SecretaryWaitingList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: -1
    };
  }

  openTab = i => {
    this.setState({ activeTab: i });
  };
  renderOpenTab = i => {
    return (
      <div className="column has-text-centered ">
        {this.state.activeTab === -1 ? (
          <h2 className="title">{this.props.getAllDoctors.allUsers[i].name}</h2>
        ) : null}

        <List
          doctorId={this.props.getAllDoctors.allUsers[i].id}
          slots={this.props.slots.filter(
            s =>
              s.doctor.id === this.props.getAllDoctors.allUsers[i].id &&
              moment(s.startTime).isSame(moment(), "day")
          )}
          colors={this.props.colors}
        />
      </div>
    );
  };

  componentWillReceiveProps(newProps) {}
  render() {
    if (this.props.getAllDoctors.loading) {
      return <p>laoding docs</p>;
    }
    let docTabs = this.props.getAllDoctors.allUsers.map((doc, i) => {
      return (
        <li key={i} className={this.state.activeTab === i ? "is-active" : ""}>
          <a onClick={() => this.openTab(i)}>{doc.name}</a>
        </li>
      );
    });
    let tabs = null;

    if (this.props.getAllDoctors.allUsers.length === 2) {
      tabs = (
        <div className="columns is-centered ">
          <div className="colum ">
            <div className="tabs is-centered">
              <ul>
                <li className={this.state.activeTab === -1 ? "is-active" : ""}>
                  <a onClick={() => this.openTab(-1)}>Tous</a>
                </li>
                {docTabs}
              </ul>
            </div>
          </div>
        </div>
      );
    }
    if (this.props.getAllDoctors.allUsers.length > 2) {
      tabs = (
        <div className="columns is-centered ">
          <div className="colum ">
            <div className="tabs is-centered">
              <ul>{docTabs}</ul>
            </div>
          </div>
        </div>
      );
    }
    return (
      <React.Fragment>
        {tabs}

        <div className="columns is-centered " id="waiting-room">
          {this.state.activeTab === -1 ? (
            this.props.getAllDoctors.allUsers.map((doc, i) => {
              if (i === 0) {
                return [
                  this.renderOpenTab(i),
                  <div className="is-divider-vertical" />
                ];
              }
              return this.renderOpenTab(i, true);
            })
          ) : (
            this.renderOpenTab(this.state.activeTab)
          )}
        </div>
      </React.Fragment>
    );
  }
}
const GET_ALL_DOCTORS_QUERY = gql`
  query {
    allUsers(filter: { role: DOCTOR }) {
      id
      name
      role
    }
  }
`;

export default compose(
  graphql(GET_ALL_DOCTORS_QUERY, {
    name: "getAllDoctors"
  })
)(SecretaryWaitingList);



// WEBPACK FOOTER //
// ./src/components/utilities/SecretaryWaitingList.js